import {Toast} from "bootstrap";

// 显示Toast通知
export const showToast = (type, message) => {
    // 这里可以使用你喜欢的Toast库，如Bootstrap Toast或SweetAlert2
    const toastEl = document.getElementById('liveToast');
    if (toastEl) {
        const toast = new Toast(toastEl);
        toastEl.querySelector('.toast-body').textContent = message;
        toastEl.classList.remove('bg-success', 'bg-danger', 'bg-warning');
        toastEl.classList.add(type === 'error' ? 'bg-danger' : type === 'warning' ? 'bg-warning' : 'bg-success');
        toast.show();
    } else {
        alert(message); // 回退方案
    }
}

// 显示复制文本
export const copy = async (text) => {
    try {
        await navigator.clipboard.writeText(text)
        showToast('success', '复制成功!')
        // 可以在这里添加成功提示
    } catch (err) {
        try {
            const textarea = document.createElement('textarea')
            textarea.value = text
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)
            showToast('success', '复制成功!!')
        } catch (err) {
            showToast('error', '复制失败!')
        }
    }
}

// 获取快捷分页页码
export const pagination = (curPage, pageSize, total) => {
    const pages = Math.ceil(total / pageSize);
    let range = [];
    let start = Math.max(1, curPage - 2);
    let end = Math.min(curPage + 2, pages);

    if (curPage - 2 < 1) {
        // 如果左侧不足，则向右扩展
        end += -(curPage - 2 - 1);
    } else if (curPage + 2 > pages) {
        // 如果右侧不足，则向左扩展
        start -= ((curPage + 2) - pages);
    }

    // 确保start和end在合理范围内
    start = Math.max(1, start);
    end = Math.min(pages, end);

    for (let i = start; i <= end; i++) {
        range.push(i);
    }

    return range;
}


